import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    UpdateInternalBannerTemplateResources,
    updateInternalBannerTemplateResourcesAction
} from '../../../actions/bannersEdit/internal/updateInternalBannerTemplateResources';
import {
    REMOVE_INTERNAL_BANNER_IMAGE,
    RemoveInternalBannerImage
} from '../../../actions/imageEditor/internal/removeInternalBannerImage';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

type EpicActions = UpdateInternalBannerTemplateResources;

export const removeInternalBannerImageEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(REMOVE_INTERNAL_BANNER_IMAGE),
        mergeMap(
            (action: RemoveInternalBannerImage): Observable<EpicActions> => {
                return of(updateInternalBannerTemplateResourcesAction(action.bannerId, action.resourceId, ''));
            }
        )
    );
};
